<script>
import { mapGetters } from 'vuex';

export default {
  name: 'FreshChatWidget',

  data() {
    return {
      initialized: false,
    };
  },

  mounted() {
    this.renderWidget();
  },

  computed: {
    ...mapGetters(['userProfile']),
  },

  methods: {
    renderWidget() {
      const freshChatData = this.userProfile ? this.userProfile.third_party_tags_data.freshchat : null;

      if (!freshChatData) {
        return;
      }

      const scriptSrc = `//fw-cdn.com/${freshChatData.app_id}.js`;
      const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);

      if (existingScript) {
        this.initialized = true;
        this.configureWidget(freshChatData);
        return;
      }

      const script = document.createElement('script');
      script.src = scriptSrc;
      script.setAttribute('chat', 'true');
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.initialized = true;
        setTimeout(() => this.configureWidget(freshChatData), 500);
      };

      document.head.appendChild(script);
    },

    configureWidget(freshChatData) {
      if (!window.fcWidget || !this.initialized) {
        return;
      }

      window.fcWidget.setExternalId(freshChatData.user_id.toString());
      window.fcWidget.user.setFirstName(freshChatData.first_name);
      window.fcWidget.user.setEmail(freshChatData.email);
      window.fcWidget.user.setProperties(freshChatData.attributes);
      window.fcWidget.user.setLocale('en');
    },
  },

  render() {
    return undefined;
  },
};
</script>
